
import { defineComponent, SetupContext, toRefs, watch } from "vue";
import { BeaconLogInfo } from "@/types/common";
import NativeClient from "@/client/native-client";
import { PAGE_ID } from "@/const/log-const";

export default defineComponent({
  name: "CommonDialog",
  props: {
    /**
     * ダイアログのアクティブ状態 (true: 活性、false: 非活性)
     */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * ダイアログに表示するタイトル
     */
    title: {
      type: String
    },
    /**
     * ダイアログに表示するテキストメッセージ
     */
    message: {
      type: String,
      required: true
    },
    /**
     * ダイアログのボタンに表示するテキスト(キャンセル)
     */
    negativeLabel: {
      type: String,
      required: false,
      default: "キャンセル"
    },
    /**
     * ダイアログのボタンに表示するテキスト(リトライ)
     */
    positiveLabel: {
      type: String,
      required: false,
      default: "リトライ"
    }
  },
  setup(props, context: SetupContext) {
    // メッセージ変化の監視
    const { message } = toRefs(props);
    watch(message, () => {
      NativeClient.sendDebugLog("CommonDialog watch");
      if (message.value != "") {
        NativeClient.sendDebugLog("CommonDialog watch log enable");
        const logInfo = new BeaconLogInfo(PAGE_ID.DIALOG, null, [message.value]);
        NativeClient.sendViewedLog(logInfo);
      }
    });

    /**
     * キャンセルボタンが押されたことを通知する
     */
    const negativeClicked = () => context.emit("negative-click");
    /**
     * リトライボタンが押されたことを通知する
     */
    const positiveClicked = () => context.emit("positive-click");

    return {
      negativeClicked,
      positiveClicked
    };
  }
});
